/**
 * @ipc/admin-ui · shared/config/env — доступ к клиентским env (Vite import.meta.env).
 * Только VITE_-переменные доступны в браузере (Vite подставляет их при сборке).
 * В dev /api и /admin проксируются на backend (см. vite.config.ts), поэтому базовый
 * путь запросов — относительный (''), а X-Tenant-Id берётся из VITE_TENANT_ID.
 */

function readEnv(key: string, fallback: string): string {
  const value = import.meta.env[key];
  return typeof value === 'string' && value.length > 0 ? value : fallback;
}

/**
 * Базовый URL API. Пусто ('') означает same-origin — запросы идут на текущий хост
 * и проксируются (dev: Vite proxy; prod: Elysia-статик-сервер проксирует /api,/admin).
 */
export const API_BASE_URL = readEnv('VITE_API_BASE_URL_CLIENT', '');

/** Slug тенанта для заголовка X-Tenant-Id на admin-маршрутах. */
export const TENANT_ID = readEnv('VITE_TENANT_ID', 'default');

/**
 * Username Telegram-бота (без @) для data-telegram-login атрибута Login Widget.
 * Бот должен быть привязан к домену деплоя admin-ui в BotFather (/setdomain).
 */
export const TELEGRAM_BOT_USERNAME = readEnv('VITE_TELEGRAM_BOT_USERNAME', '');
